import "../lib/public_path";
import "../stylesheets/ds.style.css";
import "../stylesheets/booking-engine.style.css";
import "@amenitiz/payment-frontend/dist/style.css";
import "jquery-ui/dist/themes/base/jquery-ui.css";
import "jquery.maskedinput/src/jquery.maskedinput";
import "bootstrap";
import "bootstrap-datepicker";
import "bootstrap-toggle";
import "cloudinary-jquery";
import "data-confirm-modal";
import "../lib/websites/flickity";
import _ from "underscore";
window._ = _;
import "../lib/websites/bxslider";
import "../lib/websites/fittext";
import "../lib/websites/masonry.pkgd";
import "imagesloaded";
import "../lib/websites/fullscreen";
import ReactRailsUJS from "../lib/react_rails";
if (window) window.ReactRailsUJS = ReactRailsUJS;
ReactRailsUJS.detectEvents();
window.setTimeout(() => {
  $(".alert").delay(2000).fadeOut(3000);
});